import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pager({ page, pages, total, onPage, testId = "pager" }) {
  if (!pages || pages <= 1) return null;
  return (
    <div className="flex items-center justify-between gap-3 px-5 py-4" data-testid={testId}>
      <p className="text-xs text-emerald-100/50">
        Page {page} of {pages}{typeof total === "number" ? ` · ${total.toLocaleString()} total` : ""}
      </p>
      <div className="flex gap-2">
        <button
          onClick={() => onPage(page - 1)}
          disabled={page <= 1}
          data-testid={`${testId}-prev`}
          className="inline-flex items-center gap-1 rounded-lg border border-emerald-500/20 px-3 py-1.5 text-xs text-emerald-100/80 transition-colors hover:border-lime-400/50 hover:text-white disabled:cursor-not-allowed disabled:opacity-30"
        >
          <ChevronLeft size={14} /> Prev
        </button>
        <button
          onClick={() => onPage(page + 1)}
          disabled={page >= pages}
          data-testid={`${testId}-next`}
          className="inline-flex items-center gap-1 rounded-lg border border-emerald-500/20 px-3 py-1.5 text-xs text-emerald-100/80 transition-colors hover:border-lime-400/50 hover:text-white disabled:cursor-not-allowed disabled:opacity-30"
        >
          Next <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
